export const ErrorCode = {
    // ── Auth ────────────────────────────────────────────────────
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    TOKEN_INVALID: 'TOKEN_INVALID',
    INSUFFICIENT_PERMISSION: 'INSUFFICIENT_PERMISSION',
    // ── Tenant ──────────────────────────────────────────────────
    TENANT_NOT_FOUND: 'TENANT_NOT_FOUND',
    // ── User ────────────────────────────────────────────────────
    USER_NOT_FOUND: 'USER_NOT_FOUND',
    USER_ALREADY_EXISTS: 'USER_ALREADY_EXISTS',
    USER_NOT_PROVISIONED: 'USER_NOT_PROVISIONED', // valid Firebase token but no DB user yet
    USER_INACTIVE: 'USER_INACTIVE',
    // ── Location ────────────────────────────────────────────────
    LOCATION_NOT_FOUND: 'LOCATION_NOT_FOUND',
    LOCATION_HAS_FUTURE_APPOINTMENTS: 'LOCATION_HAS_FUTURE_APPOINTMENTS',
    // ── Patient ─────────────────────────────────────────────────
    PATIENT_NOT_FOUND: 'PATIENT_NOT_FOUND',
    // ── Appointment ─────────────────────────────────────────────
    APPOINTMENT_NOT_FOUND: 'APPOINTMENT_NOT_FOUND',
    APPOINTMENT_CONFLICT: 'APPOINTMENT_CONFLICT',
    APPOINTMENT_TIME_INVALID: 'APPOINTMENT_TIME_INVALID',
    APPOINTMENT_ALREADY_CANCELLED: 'APPOINTMENT_ALREADY_CANCELLED',
    APPOINTMENT_NOT_STARTABLE: 'APPOINTMENT_NOT_STARTABLE',
    APPOINTMENT_HAS_CONSULTATION: 'APPOINTMENT_HAS_CONSULTATION',
    APPOINTMENT_HAS_OPEN_CONSULTATION: 'APPOINTMENT_HAS_OPEN_CONSULTATION',
    APPOINTMENT_STATUS_MACHINE_OWNED: 'APPOINTMENT_STATUS_MACHINE_OWNED',
    // ── Consultation ────────────────────────────────────────────
    CONSULTATION_NOT_FOUND: 'CONSULTATION_NOT_FOUND',
    CONSULTATION_ALREADY_SIGNED: 'CONSULTATION_ALREADY_SIGNED',
    CONSULTATION_NOT_SIGNED: 'CONSULTATION_NOT_SIGNED',
    CONSULTATION_MISSING_REQUIRED_FIELDS: 'CONSULTATION_MISSING_REQUIRED_FIELDS',
    CONSULTATION_REQUIRES_PROTOCOL: 'CONSULTATION_REQUIRES_PROTOCOL',
    PROTOCOL_USAGE_NOT_FOUND: 'PROTOCOL_USAGE_NOT_FOUND',
    PROTOCOL_USAGE_ALREADY_ACTIVE: 'PROTOCOL_USAGE_ALREADY_ACTIVE',
    PROTOCOL_HAS_NO_ACTIVE_VERSION: 'PROTOCOL_HAS_NO_ACTIVE_VERSION',
    PARENT_USAGE_NOT_FOUND: 'PARENT_USAGE_NOT_FOUND',
    PROTOCOL_USAGE_STALE: 'PROTOCOL_USAGE_STALE',
    // ── Consultation Record (historia médica) ──────────────────
    RECORD_NOT_FOUND: 'RECORD_NOT_FOUND',
    RECORD_NOT_DRAFT: 'RECORD_NOT_DRAFT',
    RECORD_ALREADY_SIGNED: 'RECORD_ALREADY_SIGNED',
    RECORD_REQUIRED_SECTIONS_MISSING: 'RECORD_REQUIRED_SECTIONS_MISSING',
    RECORD_CONSULTATION_NOT_SIGNED: 'RECORD_CONSULTATION_NOT_SIGNED',
    // ── Orders ──────────────────────────────────────────────────
    IMAGING_ORDER_NOT_FOUND: 'IMAGING_ORDER_NOT_FOUND',
    IMAGING_ORDER_ALREADY_SIGNED: 'IMAGING_ORDER_ALREADY_SIGNED',
    LAB_ORDER_NOT_FOUND: 'LAB_ORDER_NOT_FOUND',
    LAB_ORDER_ALREADY_SIGNED: 'LAB_ORDER_ALREADY_SIGNED',
    // ── Suggestions ─────────────────────────────────────────────
    SUGGESTION_NOT_FOUND: 'SUGGESTION_NOT_FOUND',
    // ── Prescription ────────────────────────────────────────────
    PRESCRIPTION_NOT_FOUND: 'PRESCRIPTION_NOT_FOUND',
    PRESCRIPTION_ALREADY_SIGNED: 'PRESCRIPTION_ALREADY_SIGNED',
    // ── Invoice ─────────────────────────────────────────────────
    INVOICE_NOT_FOUND: 'INVOICE_NOT_FOUND',
    INVOICE_ALREADY_ISSUED: 'INVOICE_ALREADY_ISSUED',
    INVOICE_NOT_EDITABLE: 'INVOICE_NOT_EDITABLE',
    // ── Protocol Template ───────────────────────────────────────
    PROTOCOL_TEMPLATE_NOT_FOUND: 'PROTOCOL_TEMPLATE_NOT_FOUND',
    PROTOCOL_TEMPLATE_SEEDED_IMMUTABLE: 'PROTOCOL_TEMPLATE_SEEDED_IMMUTABLE',
    PROTOCOL_TEMPLATE_NAME_CONFLICT: 'PROTOCOL_TEMPLATE_NAME_CONFLICT',
    // ── Protocol Category ───────────────────────────────────────
    PROTOCOL_CATEGORY_NOT_FOUND: 'PROTOCOL_CATEGORY_NOT_FOUND',
    PROTOCOL_CATEGORY_SEEDED_IMMUTABLE: 'PROTOCOL_CATEGORY_SEEDED_IMMUTABLE',
    PROTOCOL_CATEGORY_NAME_CONFLICT: 'PROTOCOL_CATEGORY_NAME_CONFLICT',
    CATEGORY_IN_USE_BY_TEMPLATES: 'CATEGORY_IN_USE_BY_TEMPLATES',
    // ── Protocol ────────────────────────────────────────────────
    PROTOCOL_NOT_FOUND: 'PROTOCOL_NOT_FOUND',
    PROTOCOL_REQUIRED_BLOCK_MISSING: 'PROTOCOL_REQUIRED_BLOCK_MISSING',
    PROTOCOL_LOCKED_BLOCK_MODIFIED: 'PROTOCOL_LOCKED_BLOCK_MODIFIED',
    // ── Onboarding ──────────────────────────────────────────────
    TENANT_ALREADY_SEEDED: 'TENANT_ALREADY_SEEDED',
    ONBOARDING_ALREADY_COMPLETE: 'ONBOARDING_ALREADY_COMPLETE',
    NO_TYPES_AVAILABLE: 'NO_TYPES_AVAILABLE',
    ONBOARDING_UNKNOWN_TEMPLATE: 'ONBOARDING_UNKNOWN_TEMPLATE',
    // ── Validation ──────────────────────────────────────────────
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    // ── Schedule ────────────────────────────────────────────────
    SCHEDULE_BLOCK_NOT_FOUND: 'SCHEDULE_BLOCK_NOT_FOUND',
    SCHEDULE_BLOCK_TIME_INVALID: 'SCHEDULE_BLOCK_TIME_INVALID',
    SCHEDULE_BLOCK_OVERLAP: 'SCHEDULE_BLOCK_OVERLAP',
    SCHEDULE_EXCEPTION_NOT_FOUND: 'SCHEDULE_EXCEPTION_NOT_FOUND',
    SCHEDULE_EXCEPTION_TIME_INVALID: 'SCHEDULE_EXCEPTION_TIME_INVALID',
    // ── SSO ─────────────────────────────────────────────────────
    SSO_DOMAIN_ALREADY_CLAIMED: 'SSO_DOMAIN_ALREADY_CLAIMED',
    // ── Audit Log ───────────────────────────────────────────────
    AUDIT_LOG_NOT_FOUND: 'AUDIT_LOG_NOT_FOUND',
    AUDIT_EXPORT_REQUIRES_CLINIC_PLAN: 'AUDIT_EXPORT_REQUIRES_CLINIC_PLAN',
    // ── Generic ─────────────────────────────────────────────────
    NOT_FOUND: 'NOT_FOUND',
    RESOURCE_CONFLICT: 'RESOURCE_CONFLICT',
    RATE_LIMITED: 'RATE_LIMITED',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
};
//# sourceMappingURL=errors.js.map